<template>
  <div v-if="material.thickness" class="card card-material-summary mt-2" :class="{'d-none': !showSummary}">
    <div class="card-body pb-0">
      <div class="card-title">
        <template v-if="materialBruto">Totale plaatdikte</template>
        <template v-else>Totale paneeldikte</template>
        <div class="card-title-right float-right">{{ totalThickness }}</div>
      </div>

      <div class="card-title">
        <div class="card-title-right float-right mb-3">
          <div
            v-for="(dimension, index) in maxPanelDimensions()"
            :key="index"
            class="d-block"
          >{{ dimension.length }} x {{ dimension.width }}</div>
        </div>
        <template v-if="materialBruto">Max. plaatafmeting<span v-if="maxPanelDimensions().length > 1">en</span></template>
        <template v-else>Max. paneelafmeting<span v-if="maxPanelDimensions().length > 1">en</span></template>
        <div v-if="material.finish && material.finish.code !== 'none' && material.finish.code !== 'np'" class="card-title card-title-comment">
          &nbsp;(Inclusief kantenband)
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_TOTAL_THICKNESS, SET_MATERIAL_TOTAL_LENGTH, SET_MATERIAL_TOTAL_WIDTH, SET_MATERIAL_TOTAL_DIMENSIONS } from '../../../store/types'
  import {EventBus} from "@/bus";

  export default {
    data() {
      return {
        showSummary: true
      }
    },
    computed: {
      material() {
        return this.$store.getters.material
      },
      materialBruto() {
        return this.$store.getters.materialBruto
      },
      finish() {
        return !this.$store.getters.materialFinish ? false : this.$store.getters.materialFinish
      },
      totalThickness() {
        let total = parseFloat(this.material.thickness)

        let side1 = this.material.side1
        if (side1) {
          total += parseFloat(side1.thickness)
        }
        let side2 = this.material.side2
        if (side2) {
          total += parseFloat(side2.thickness)
        }

        total = Math.round(total * 100) / 100
        this.$store.dispatch(SET_MATERIAL_TOTAL_THICKNESS, total)

        return total + ' mm'
      }
    },
    methods: {
      maxPanelDimensions() {
        // Don't show on Meubelpanelen
        if (this.$store.getters.filterDeliveryProgram === 'Meubelpanelen') {
          this.showSummary = false
          return ''
        }

        // Alle breedtes (kleinste) + alle lengtes (pak kleinste)
        let code = this.$store.getters.materialCode
        let product = this.$store.getters.product(code)
        if (!product) {
          product = this.material.product
        }
        if (!product) {
          this.showSummary = false
          return ''
        }

        let length = parseFloat(product.length)
        let width = parseFloat(product.width)

        let side1 = this.material.side1
        if (side1) {
          length = side1.length > length ? length : side1.length
          width = side1.width > width ? width : side1.width
        }

        let side2 = this.material.side2
        if (side2) {
          length = side2.length > length ? length : side2.length
          width = side2.width > width ? width : side2.width
        }

        // Store the raw length/width
        this.$store.dispatch(SET_MATERIAL_TOTAL_LENGTH, length)
        this.$store.dispatch(SET_MATERIAL_TOTAL_WIDTH, width)

        // Store the raw dimensions
        let dimensions = [{
          length: parseFloat(length),
          width: parseFloat(width)
        }]

        this.$store.dispatch(SET_MATERIAL_TOTAL_DIMENSIONS, dimensions)
        setTimeout(function() {
          EventBus.$emit('update-dimensions')
        }, 100)

        this.showSummary = true

        // For display: Substract xxmm from both sides
        if (this.materialBruto) {
          return dimensions
        } else {
          return [{
            length: parseFloat(length) - 30,
            width: parseFloat(width) - 30
          }]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-material-summary {
    background-color: #fafafa;
  }

  .card-title {
    font-weight: bold;
    font-size: 0.9em;
  }

  .card-title-right {
    font-size: 0.9em;
  }

  .card-title-comment {
      font-size: 0.9em;
      display: inline;
  }
</style>
